import { render, staticRenderFns } from "./JBProposalWindowsDisplay.vue?vue&type=template&id=736ba820"
import script from "./JBProposalWindowsDisplay.vue?vue&type=script&lang=js"
export * from "./JBProposalWindowsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports